import axios from "axios";
import { cnxAPI, notifica, show_ldr, getUser } from "../requests/utils";
import api from "../service/api";

var a = null,
  b = null,
  c = null,
  d = null;

//Function delete Idiomas
function deleteIdiomas(data) {
  api.post("candidatos/agregar-idioma", { ...data, eliminar: true, idCandidato: getUser().idCandidato })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        localStorage.removeItem("frmIdms");
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
}

//Función que guarda datos de Idiomas
function saveIdiomas(_callback, datos, editar) {
  var json = getDataFrm(".frmIdms");
  var contador = 0;
  if (editar === false) {
    var pJSon = JSON.parse(json);

    datos.map((valor) => {
      if (valor.IdIdioma === parseInt(pJSon.IdIdioma)) {
        return contador++;
      }
      return null;
    });
  }

  if (contador === 0) {
    show_ldr(true);
    json = JSON.parse(json);
    json.eliminar = json.eliminar === "true";
    api.post("candidatos/agregar-idioma", json)
      .then(function (response) {
        show_ldr(false);
        if (response.status !== 200) {
          notifica("warning", response.data.message || "Error desconocido", "Alerta!");
        } else {
          localStorage.removeItem("frmIdms");
          a = response;
        }
      })
      .catch(function (error) {
        notifica("danger", error, "Error");
      })
      .then(() => _callback(a));
  } else {
    notifica("warning", "Ya se encuentra registrado el idioma", "Error");
  }
}

//JSON CONVERT
function getDataJson(clase) {
  let json = {};
  let inps = document.querySelectorAll(clase),
    usr = getUser(),
    amI = "",
    amF = "";

  json = { ...json, idCandidato: usr.idCandidato };

  inps.forEach(function (i) {
    var nm = i.getAttribute("datsvfrm"),
      tg = i.type,
      vl = tg !== "checkbox" ? i.value : i.checked ? "true" : "false";

    if (!i.className.includes("Hide_Half")) {
      if (nm === "anioMesInicioA" || nm === "anioMesInicioM") {
        amI += amI === "" ? vl : "-" + vl;
        json = amI.includes("-")
          ? (json = { ...json, anioMesInicio: amI })
          : { ...json };
      } else if (nm === "anioMesFinA" || nm === "anioMesFinM") {
        amF += amF === "" ? vl : "-" + vl;
        json = amF.includes("-") ? { ...json, anioMesFin: amF } : { ...json };
      } else {
        json = { ...json, [nm]: vl };
      }
    }
  });
  return json;
}

//Función que obtiene datos de un form
function getDataFrm(clase) {
  var inps = document.querySelectorAll(clase),
    usr = getUser(),
    js = '{ "idCandidato":"' + usr.idCandidato + '", ',
    amI = "",
    amF = "";

  inps.forEach(function (i) {
    var nm = i.getAttribute("datsvfrm"),
      tg = i.type,
      vl = tg !== "checkbox" ? i.value : i.checked ? "true" : "false";

    if (!i.className.includes("Hide_Half")) {
      if (nm === "anioMesInicioA" || nm === "anioMesInicioM") {
        amI += amI === "" ? vl : "-" + vl;

        if (amI.includes("-")) {
          js += '"anioMesInicio":"' + amI + '",';
        }
      } else if (nm === "anioMesFinA" || nm === "anioMesFinM") {
        amF += amF === "" ? vl : "-" + vl;
        if (amF.includes("-")) {
          js += '"anioMesFin":"' + amF + '",';
        }
      } else {
        js += '"' + nm + '":"' + vl + '",';
      }
    }
  });
  js = js.substr(0, js.length - 1) + "}";
  return js;
}
function getDataDelExp(params) {
  var usr = getUser();
  var Item = {
    idCandidato: usr.idCandidato,
    idExperiencia: params,
  };
  return Item;
}
//Función que guarda datos de Experiencia profesional
function saveExpProf(data, _callback) {
  var json = data;
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/InsertExperienciaProfesional",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        localStorage.removeItem("frmExpPr");
        localStorage.removeItem("idExp2");
        if (response.data.code === 0) {
          notifica("success", "¡Se guardo correctamente.!", "");
        } else {
          notifica("warning", response.data.message, "Alerta!");
        }
        a = response.data;
        localStorage.setItem("idExp2", response.data.message);
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}
function editExpProf(data, _callback) {
  var json = data;
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/EditExperienciaProfesional",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        localStorage.removeItem("frmExpPr");
        localStorage.removeItem("idExp2");
        if (response.data.code === 0) {
          notifica("success", "¡Se guardo correctamente.!", "");
        } else {
          notifica("warning", response.data.message, "Alerta!");
        }
        a = response.data;
        localStorage.setItem("idExp2", response.data.message);
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}
function deleteExpProf(obj, _callback) {
  show_ldr(true);
  api.deleteWithBody("candidatos/experiencia-profesional", obj)
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        if (response.data.code !== 0) {
          notifica("warning", response.data.message, "Alerta!");
        } else {
          notifica("success", "¡Se borro correctamente.!", "");
        }
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}

function getPerfil(_callback = null) {
  var usr = getUser();

  show_ldr(true);
  api.get(`candidatos/${usr.idCandidato}/detalle-perfil`, {})
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        b = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
      b = null;
    })
    .then(() => _callback(b));
}

//Función para guardar "Datos Laborales"
function saveDatosLaborales(values, _callback) {
  var json = getDataFrm(".frmdl");
  if (values != null && values !== "")
    json =
      json.substr(0, json.length - 1) + ',"idsPrestaciones":"' + values + '"}';

  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/InsertPreferenciasCandidato",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        c = response.data;

        localStorage.removeItem("frmdl");
        notifica("success", "¡Se guardó correctamete!", "");
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(c));
}

//Funcion para borrar Datos laborales
function DeleteDatosLaborales(params, _callback) {
  show_ldr(true);
  api.remove(`candidatos/preferencia/${params.idPreferencias}`, {})
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        c = response;
        notifica("success", "¡Se borro correctamete!", "");
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(c));
}

//Función para guardar "Formación"
function saveFormacion(_callback, edit, tablaDatosGuardados) {
  var json = getDataFrm(".frmfcn");
  localStorage.removeItem("");
  //variable contador para indicar si ya existe la formación con el mismo nombre
  let contador = 0;
  if (edit === false) {
    var parJ = JSON.parse(json);
    parJ.idFormacionCandidato = "";
    json = parJ;

    tablaDatosGuardados.map(function (obj) {
      if (
        obj.centroEducativo === parJ.CentroEducativo &&
        obj.idNivelesEstudios === parseInt(parJ.IdNivelEstudios)
      ) {
        return contador++;
      }
      return null;
    });
  }

  if (contador === 0) {
    show_ldr(true);
    api.post("candidatos/formacion-cadidato", json)
      .then(function (response) {
        show_ldr(false);
        if (response.status !== 200) {
          notifica("warning", response.data.message, "");
        } else {
          c = response.data;
          localStorage.removeItem("frmfcn");

          notifica("success", "¡Se guardo correctamente.!", "");
        }
      })
      .catch(function (error) {
        notifica("danger", error, "Error");
      })
      .then(() => _callback(c));
  } else {
    notifica("warning", "Ya se encuentra registrado esta formación", "Error");
    _callback(c);
  }
}
//Función para Borrar "Formación"
function getDataDelFormacion(params) {
  var usr = getUser();
  var Item = {
    idCandidato: usr.idCandidato,
    idFormacionCandidato: params,
  };
  return Item;
}
function deleteFormacion(params, _callback) {
  var json = params;

  show_ldr(true);
  api.deleteWithBody("candidatos/formacion", json)
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "");
      } else {
        c = response.data;
        localStorage.removeItem("frmfcn");
        notifica("success", "¡Se borro correctamente.!", "");
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(c));
}

function axSaveEditConocimiento(
  idCandidato,
  IdConocimiento,
  idNivel,
  conocimiento
) {
  show_ldr(true);
  return new Promise((resolve) => {
    var json = {
      idCandidato: idCandidato,
      idConocimiento: IdConocimiento,
      IdNivel: idNivel,
      conocimiento: conocimiento,
    };
    api.put("candidatos/editar-conocimientos", json)
      .then(function (response) {
        show_ldr(false);

        if (response.ok) {
          notifica("success", "Se ha guardado correctamente", "");
          resolve(true);
        } else {
          notifica("warning", response.data.message, "Alerta!");
          resolve(false);
        }
      })
      .catch(function (error) {
        notifica("danger", error, "Error");
        show_ldr(false);
        resolve(false);
      });
  });
}
//función para eliminar conocimiento tecnico
function axEliminarConocimiento(idCandidato, IdConocimiento) {
  show_ldr(true);
  return new Promise((resolve) => {
    var json = { idCandidato: idCandidato, idConocimiento: IdConocimiento };
    api.deleteWithBody("candidatos/eliminar-conocimiento", json)
      .then(function (response) {
        show_ldr(false);

        if (response.ok) {
          notifica("success", "Se ha eliminado correctamente", "");
          resolve(true);
        } else {
          notifica("warning", response.data.message, "Alerta!");
          resolve(false);
        }
      })
      .catch(function (error) {
        notifica("danger", error, "Error");
        show_ldr(false);
        resolve(false);
      });
  });
}
//Función para guardar "Conocimientos técnicos"
function saveConocimientos(_callback) {
  var json = getDataFrm(".frmCncmnt");
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/InsertConocimientosCandidato",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "");
      } else {
        c = response.data;
        notifica("success", "Se Guardó Correctamente.", "");
        localStorage.removeItem("frmCncmnt");
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(c));
}

//Función para guardar foto
function saveFoto(_callback) {
  var usr = getUser(),
    fot = document.getElementById("inp_fl"),
    arc = fot.files[0];

  if (arc == null) {
    notifica("warning", "Debe de subir una imagen", "");
    return _callback(1000);
  }
  if (arc.type !== "image/png" && arc.type !== "image/jpeg") {
    notifica("warning", "Formato no permitido", "");
    return _callback(1000);
  }

  var tamano = arc.size;
  tamano = parseInt(tamano / 1024);
  if (tamano > 2000) {
    notifica(
      "warning",
      "El peso de la imagen debe ser menor o igual a 2 mb.",
      ""
    );
    return _callback(1000);
  }

  let js = { idCandidato: usr.idCandidato };
  var BFD = new FormData();
  BFD.set("info", JSON.stringify(js));
  BFD.set("archivo", arc);

  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/CambiarFotoPerfil",
    headers: {
      "Content-Type": "multipart/form-data",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: BFD,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.data != null) {
        if (response.data.code === 0) {
          c = response.data;
          notifica("success", "Se Guardo Correctamente.", "Alerta!");
        } else {
          notifica("warning", response.data.message, "Alerta!");
        }
      } else {
        notifica(
          "warning",
          "Algo ocurrió al configurar la solicitud que provocó un error",
          "Alerta!"
        );
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(c));
}

//Función para guardar los datos de Información personal
function savePData(datosOriginales, _callback) {
  var val = (id) => document.getElementById(id).value,
    fot = document.getElementById("inp_arcCV"),
    arc = fot.files[0],
    idCandidato = getUser().idCandidato,
    bodyFormData = new FormData();

  bodyFormData.set("primerNombre", val("primerNombre"));
  bodyFormData.set("apellidoPaterno", val("apellidoPaterno"));
  bodyFormData.set("apellidoMaterno", val("apellidoMaterno"));
  bodyFormData.set("fechaNacimiento", val("FechaNacim"));
  bodyFormData.set("sexo", val("IdGenero"));
  bodyFormData.set("idEstadoCivil", val("IdEstadoCiv"));
  bodyFormData.set("idPais", val("IdNacionalidad"));
  bodyFormData.set("idEstado", val("IdEstado"));
  bodyFormData.set("idMunicipio", val("IdMunicipio"));
  bodyFormData.set("idCiudad", val("IdMunicipio"));
  bodyFormData.set("CodigoPostal", val("IdCodigoPostal"));
  bodyFormData.set("telefono1", val("telefono1"));
  bodyFormData.set("Celular", val("telefono2"));
  bodyFormData.set("Direccion", val("direccion"));

  if (arc) bodyFormData.set("archivoCv", arc);

  //Passthrough de campos no editables en este formulario, para no sobreescribirlos con vacío
  if (datosOriginales?.correo) bodyFormData.set("correo", datosOriginales.correo);

  api.put(`candidatos/${idCandidato}`, bodyFormData)
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        c = response.data;

        localStorage.removeItem("frm_Prfl_IP");
        notifica("success", "Se Guardó Correctamente", "");
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(c));
}

//CONSULTA PRGUNTAS DE RH
function getPreguntas(_callback) {
  var usr = getUser();
  show_ldr(true);
  api.get(`preguntas-generales/preguntas-rh?idCandidato=${usr.idCandidato}`, {})
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
        d = [];
      } else {
        d = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(d));
}

function getPreguntasTecnicas(_callback, id) {
  var usr = getUser();

  show_ldr(true);
  api.get(`preguntas-generales/preguntas-tecnicas?idSolicitud=${id}&idCandidato=${usr.idCandidato}`, {})
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
        d = [];
      } else {
        d = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
      d = [];
    })
    .then(() => _callback(d));
}

function getColonias(_callback, idE, idM) {
  alert("idestado:" + idE);
  alert("idmunicipio:" + idM);
  var //usr = getUser(),
    json = { idEstado: idE, idMunicipio: idM };

  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "catColonias/GetAll",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        d = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(d));
}
function getCategorias(_callback) {
  var //usr = getUser(),
    json = {};

  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "General/Categoria",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        b = response.data.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(b));
}
var dat_secciones = [
  { ubicacion: "izquierda", seccion: "Información personal", sc: "IP" },
  { ubicacion: "izquierda", seccion: "Experiencia profesional", sc: "EP" },
  { ubicacion: "derecha", seccion: "Conocimientos Técnicos", sc: "CT" },
  { ubicacion: "izquierda", seccion: "Formación", sc: "FM" },
  { ubicacion: "derecha", seccion: "Idiomas", sc: "ID" },
  { ubicacion: "izquierda", seccion: "Datos Laborales", sc: "DL" },
];

var dat_RH = [
  {
    IdPregunta: 1,
    descripcion: "¿Cuales son tus mejores cualidades?",
    idEstatus: 1,
  },
  {
    IdPregunta: 2,
    descripcion: "¿Que opinaría tu último jefe de ti?",
    idEstatus: 0,
  },
  {
    IdPregunta: 3,
    descripcion: "¿Menciona tus objetivos a largo plazo?",
    idEstatus: 0,
  },
  {
    IdPregunta: 4,
    descripcion:
      "Cuales consideras que son tus puntos que debes reforzar en cuanto a valores y otras cosas importantes, este es una prueba cuando tienes preguntas muy largas, o demasiado elaboradas, y como se debería de mostrar en pantalla para que se vea bien, y no demasiado elaborado y puedas contestar correctamente.",
    idEstatus: 1,
  },
  {
    IdPregunta: 5,
    descripcion: "¿Cuales son tus objetivos a corto plazo?",
    idEstatus: 0,
  },
];

var dat_conoc = [
  {
    IdConocimiento: 1,
    conocimiento: "Javascript",
    nivel: 3,
    descNivel: "Avanzado",
  },
  { IdConocimiento: 2, conocimiento: "C#", nivel: 2, descNivel: "Intermedio" },
  { IdConocimiento: 3, conocimiento: "Jquery", nivel: 1, descNivel: "Básico" },
  {
    IdConocimiento: 4,
    conocimiento: "SQL Server",
    nivel: 4,
    descNivel: "Experto",
  },
  { IdConocimiento: 5, conocimiento: "HTML", nivel: 3, descNivel: "Avanzado" },
];

var dat_idms = [
  {
    IdIdioma: 1,
    idioma: "Inglés",
    nvOral: "Avanzado",
    nvEscrito: "Intermedio",
    nvLectura: "Intermedio",
  },
  {
    IdIdioma: 2,
    idioma: "Frances",
    nvOral: "Intermedio",
    nvEscrito: "Básico",
    nvLectura: "Básico",
  },
];

var dat_exp = [
  {
    IdExperiencias: 1,
    empresa: "Softtek",
    giroempresa: "Servicios",
    cargo: "Desarrollador Jr.",
    categoria: "Tecnologías de la Información",
    funciones:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed dignissimos esse fuga! Minus, alias.",
    bActual: true,
    fechaInicio: "Junio-2019",
    fechaFin: null,
  },
  {
    IdExperiencias: 2,
    empresa: "Grupo Salinas",
    giroempresa: "Servicios",
    cargo: "Analista de Sistemas",
    categoria: "Tecnologías de la Información",
    funciones:
      "Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit, This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.",
    bActual: false,
    fechaInicio: "Enero-2018",
    fechaFin: "Mayo-2019",
  },
];

var dat_frmc = [
  {
    IdFormacion: 1,
    centroeducativo: "UNAM",
    formacion: "Maestría en TI",
    area: "Tecnologías de la Información",
    estatus: "Finalizado",
    fechainicio: "Junio-2015",
    fechafin: "Enero-2019",
    duracion: "3.5 años",
  },
];

var dat_enc = [
  {
    IdEncuesta: 1,
    pregunta: "¿Cuales son tus mejores cualidades?",
    pendiente: false,
  },
  {
    IdEncuesta: 2,
    pregunta: "¿Que opinaría tu último jefe de ti?",
    pendiente: true,
  },
  {
    IdEncuesta: 3,
    pregunta: "¿Menciona tus objetivos a largo plazo?",
    pendiente: false,
  },
];

export {
  dat_secciones,
  dat_conoc,
  dat_idms,
  dat_exp,
  dat_frmc,
  dat_enc,
  saveIdiomas,
  saveExpProf,
  editExpProf,
  getPerfil,
  saveDatosLaborales,
  saveFormacion,
  saveConocimientos,
  saveFoto,
  dat_RH,
  getPreguntas,
  getPreguntasTecnicas,
  savePData,
  getColonias,
  getCategorias,
  getDataFrm,
  getDataJson,
  getDataDelExp,
  deleteExpProf,
  deleteFormacion,
  getDataDelFormacion,
  DeleteDatosLaborales,
  deleteIdiomas,
  axEliminarConocimiento,
  axSaveEditConocimiento,
};
